(() => {
  if (window.ulGrillzProductLoaded) return;
  window.ulGrillzProductLoaded = true;

  const parse = (value) => {
    const normalized = value.replace('Weissgold', 'Weißgold').replace(/^(14|18)kt\s+(.+)$/, '$2 $1kt');
    const gold = normalized.match(/^(Gelbgold|Weißgold|Roségold)\s+(14|18)kt$/);
    if (gold) return { group: gold[1], karat: gold[2] };
    if (value === 'Chrom') return { group: 'Chrom' };
    if (value === 'Chrom Vergoldung' || value === 'Chrom Vergoldet') return { group: 'Vergoldet' };
    return { group: value };
  };
  const colors = { Chrom: 'silver', Vergoldet: 'gold', Gelbgold: 'gold', Weißgold: 'whitegold', Roségold: 'rose' };
  const initialize = () => {
    document.querySelectorAll('.productView').forEach((product) => {
      if (!product.querySelector('.ul-grillz-purchase')) return;
      product.classList.add('ul-grillz-product');
      product.querySelectorAll('variant-selects select[name="options[Material]"]').forEach((select) => {
        if (select.dataset.ulEnhanced) return;
        const native = select.closest('.product-form__input');
        if (!native) return;
        const options = Array.from(select.options);
        const groups = [...new Set(options.map((option) => parse(option.value).group))];
        if (groups.length < 2) return;
        const ui = document.createElement('div');
        ui.className = 'ul-material-picker';
        const heading = document.createElement('p');
        heading.className = 'ul-material-picker__heading';
        heading.innerHTML = 'Material <span class="ul-material-picker__selected"></span>';
        const row = document.createElement('div');
        row.className = 'ul-material-picker__materials';
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', 'Material wählen');
        const karatRow = document.createElement('div');
        karatRow.className = 'ul-material-picker__karat';
        karatRow.setAttribute('role', 'group');
        karatRow.setAttribute('aria-label', 'Goldlegierung wählen');
        const karatTitle = document.createElement('p');
        karatTitle.className = 'ul-material-picker__heading';
        karatTitle.textContent = 'Goldlegierung';
        const karatSection = document.createElement('div');
        karatSection.className = 'ul-material-picker__legierung';
        karatSection.append(karatTitle, karatRow);
        let preferredKarat = parse(select.value).karat || '14';
        const choose = (option) => {
          if (!option || option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        };
        groups.forEach((group) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ul-material-picker__button';
          button.dataset.group = group;
          const swatch = document.createElement('span');
          swatch.className = `ul-material-picker__swatch ul-material-picker__swatch--${colors[group] || 'silver'}`;
          swatch.setAttribute('aria-hidden', 'true');
          const label = document.createElement('span');
          label.textContent = group;
          button.append(swatch, label);
          button.addEventListener('click', () => {
            const available = options.filter((option) => parse(option.value).group === group && !option.disabled);
            choose(available.find((option) => parse(option.value).karat === preferredKarat) || available[0]);
          });
          row.append(button);
        });
        ['14', '18'].forEach((karat) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ul-material-picker__karat-button';
          button.dataset.karat = karat;
          button.textContent = `${karat} Karat`;
          button.addEventListener('click', () => {
            const group = parse(select.value).group;
            preferredKarat = karat;
            choose(options.find((option) => parse(option.value).group === group && parse(option.value).karat === karat));
          });
          karatRow.append(button);
        });
        const sync = () => {
          const selected = parse(select.value);
          if (selected.karat) preferredKarat = selected.karat;
          heading.querySelector('span').textContent = select.selectedOptions[0]?.textContent || select.value;
          row.querySelectorAll('button').forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.group === selected.group));
            button.disabled = !options.some((option) => parse(option.value).group === button.dataset.group && !option.disabled);
          });
          karatSection.hidden = !selected.karat;
          karatRow.querySelectorAll('button').forEach((button) => {
            const option = options.find((option) => parse(option.value).group === selected.group && parse(option.value).karat === button.dataset.karat);
            button.hidden = !option;
            button.disabled = !option || option.disabled;
            button.setAttribute('aria-pressed', String(button.dataset.karat === selected.karat));
          });
        };
        ui.append(heading, row, karatSection);
        native.insertAdjacentElement('afterend', ui);
        select.dataset.ulEnhanced = 'true';
        native.classList.add('ul-material-picker__native');
        select.addEventListener('change', sync);
        new MutationObserver(sync).observe(select, { subtree: true, attributes: true, attributeFilter: ['disabled', 'selected'] });
        sync();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
